<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.title-box {
  display: flex;
  align-items: center;
  padding-left: 50px;
}
.title-box-name {
  width: 110px;
  flex-shrink: 0;
  text-align: right;
}
.title-box-name span {
  color: red;
}
.el-col-6{
  display: flex;
}
.ipt-sty{
  flex: 1;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div" >公司名称</div>
          <el-select
            v-model="page.tenantGuid"
            placeholder="请选择"
            filterable
            size="mini"
            class="ipt-sty"
            @change="companyChange"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div" >药店名称</div>
          <el-input v-model="page.customerName" class="ipt-sty" placeholder="请输入药店名称" clearable></el-input
        ></el-col>
        <el-col :span="6"
          ><div class="search-area-div" >所属省份</div>
          <el-select v-model="page.province" placeholder="请选择" class="ipt-sty" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? "收起筛选" : "更多筛选" }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)"
            >搜索</el-button
          >
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore" class="mt15">
        <!-- <el-col :span="8"
          ><div class="search-area-div" style="width: auto">维护状态：</div>
          <el-select v-model="page.maintainState" placeholder="请选择" class="ipt-sty w70f" clearable>
            <el-option v-for="item in maintenanceStatusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="6"
          ><div class="search-area-div">药店属性</div>
          <el-select
            v-model="page.terminalProperties"
            placeholder="请选择"
            class="ipt-sty"
            clearable
            multiple
            collapse-tags
          >
            <el-option v-for="item in customerTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>

        <!-- <el-col :span="8"
          ><div class="search-area-div" style="width: auto">建档方式：</div>
          <el-select v-model="page.filingMethod" placeholder="请选择" class="ipt-sty w70f" clearable>
            <el-option v-for="item in filingMethodList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="6" >
          <div class="search-area-div">人员信息</div>
          <el-input v-model="page.staffInfo" class="ipt-sty" placeholder="请输入姓名/手机号" clearable></el-input
        ></el-col>
        
      </el-row>
    </div>
    <div class="back-color-fff content-main-box" 
    :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area p16">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addPath">添加药店</el-button>
        <el-button icon="el-icon-plus" size="mini" type="info" @click="batchImport">批量导入</el-button>
        <el-button size="mini" type="info" @click="report" v-loading.fullscreen.lock="fullscreenLoading"
          >批量导出</el-button
        >
        <!-- <el-button size="medium" type="info" @click="openMiantainState(1)" v-loading.fullscreen.lock="fullscreenLoading"
          >批量标记状态</el-button
        > -->
        <el-button size="mini" type="info" @click="batchCustomer">批量分配客户</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        ref="multipleTable"
        v-loading="tableLoading"
        :height="tableHeight" 
        tooltip-effect="light"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :row-key="(row) => row.guid"
        @row-click="handleClickTableRow"
      >
        <el-table-column type="selection" :reserve-selection="true" width="40" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="customerCode" width="150" label="药店编码" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.customerCode || '-' }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="customerName"
          width="150"
          label="药店名称"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="terminalProperty" width="150" label="药店属性" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.terminalProperty || '-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="region" label="大区" header-align="center" width="150" align="center">
          <template slot-scope="scope">{{ scope.row.region}}</template>
        </el-table-column>   -->
        <el-table-column prop="venue" width="150" label="省" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.province | province }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="150" label="市" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.city | city }}</template>
        </el-table-column>
        <el-table-column prop="venue" width="150" label="区/县" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.district | district }}</template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="详细地址"
          width="150"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="contacts" width="150" label="药店联系人" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.contacts || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="contactTel" width="150" label="药店联系电话" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.contactTel || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" width="150" label="业务指派人员" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.staffName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="mobileNo" width="150" label="指派人手机号" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.mobileNo || '-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="contactTel" width="100" label="建档方式" header-align="center"  align="center">
                <template slot-scope="scope">
            {{ scope.row.contactTel ||'-' }}
          </template> 
        </el-table-column> -->
        <!-- <el-table-column prop="contactTel" width="100" label="维护状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.maintainState | maintainState }}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" header-align="center" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="editPath(scope.row.guid)">编辑 | </a>
            <!-- <a class="txt-color" @click="openMiantainState(2, scope.row.guid)">标记状态 | </a> -->
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="标记维护状态" :visible.sync="dialogVisible" width="400px">
      *维护状态：
      <el-radio-group v-model="maintainState">
        <el-radio :label="0">未处理</el-radio>
        <el-radio :label="1">已维护</el-radio>
        <el-radio :label="2">无需处理</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateMiantainState()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量分配客户 -->
    <el-dialog title="批量分配客户" :visible.sync="dialogCustomer" width="550px" :close-on-click-modal="false">
      <div class="title-box">
        <div class="title-box-name"><span> </span>所属企业：</div>
        {{ tenantName }}
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span> </span>已选客户：</div>
        {{ this.multipleSelection.length }}
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span>*</span>分配人员：</div>
        <el-select v-model="staffForm.staffGuid" filterable placeholder="请选择" class="w60f" @change="changeStaff">
          <el-option
            v-for="item in staffList"
            :key="item.guid"
            :label="item.staffName + ' - ' + item.mobileNo"
            :value="item.guid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="title-box mt15" v-show="staffForm.staffGuid">
        <div class="title-box-name"><span> </span>所属部门：</div>
        {{ organisationNames || '-' }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogCustomer = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitFormStaff()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      showMore: false, // 筛选项显示更多
      tableHeight: window.innerHeight - 274,
      contentMainHeight:window.innerHeight - 200,
      dialogVisible: false,
      maintainState: 1,
      options: areaJson,
      tenantList: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        startTime: '',
        endTime: '',
        customerName: '',
        tenantGuid: '',
        // filingMethod: '',
        // maintainState: '',
        terminalProperties: [],
        staffInfo:''
      },
      tenantList: [],
      tableData: [],
      sendTime: '',
      right: 'right',
      fullscreenLoading: false,
      tableLoading: false,
      filingMethodList: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '手动建档',
        },
        {
          value: '2',
          label: '自动建档',
        },
      ],
      maintenanceStatusList: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '0',
          label: '未处理',
        },
        {
          value: '1',
          label: '已维护',
        },
        {
          value: '2',
          label: '无需处理',
        },
      ],
      customerTypeList: [
        {
          value: '单体药店',
          label: '单体药店',
        },
        {
          value: '连锁总部',
          label: '连锁总部',
        },
        {
          value: '连锁门店',
          label: '连锁门店',
        },
        {
          value: '诊所',
          label: '诊所',
        },
        {
          value: '乡镇卫生院(含村卫生院)',
          label: '乡镇卫生院(含村卫生院)',
        },
      ],
      multipleSelectionGuid: [],
      multipleSelection: [],
      num: '',
      //新增分配
      dialogCustomer: false,
      tenantName: '',
      organisationNames: '',
      staffList: [],
      staffForm: {
        guids: [],
        staffGuid: '',
        userGuid: '',
        staffName: '',
      },
    };
  },
  activated() {
    if(this.page.tenantGuid){
      this.getData(false);
    }
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 324;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 274;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() { 
      this.getTenantOperationRelList(true);
      this.getFormConfig();
  }, 
  methods: { 
    //获取配置
    getFormConfig() {
      this.api.get(
        `/${serverConfig.msConfigureService}/function/func/get-by-code?functionCode=KAYDJD`
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = resp.data.data;
          if(data&&data.fieldList){
            data.fieldList.filter(i=>{
              return (i.appSideType == '0' || i.appSideType == '1')&&i.showPosition.indexOf('1')>-1;
            })
            localStorage.setItem('KAYDJD_CONFIG',JSON.stringify(data))
          }
          if(!resp.data.data){
            localStorage.removeItem('KAYDJD_CONFIG')
          }
        } else {
          this.$message.error(res.data.msg);  
        }
      });
    },
    //点击当前行
    handleClickTableRow(row, event, column){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //批量分配
    batchCustomer() {
      if (!this.page.tenantGuid) {
        this.$message.error('请先选择所属企业！');
        return;
      }
      if (!this.tableData.length) {
        this.$message.error('暂无数据！');
        return;
      }
      if (!this.multipleSelection.length) {
        this.$message.error('请勾选数据！');
        return;
      }
      this.dialogCustomer = true;
    },
    companyChange(val) {
      this.getStaff();
      this.tenantList.forEach((i) => {
        if (i.sendTenantGuid == val) {
          this.tenantName = i.sendTenantName;
        }
      });
    },
    changeStaff(val) {
      if (this.staffList && this.staffList.length > 0) {
        this.staffList.forEach((i) => {
          if (val == i.guid) {
            this.staffForm.userGuid = i.userGuid;
            this.staffForm.staffName = i.staffName;
            this.organisationNames = i.organisationNames;
          }
        });
      }
    },
    //获取人员下拉
    getStaff() {
      this.api
        .get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=${this.page.tenantGuid}`)
        .then((res) => {
          if (res.data.msg == 'success') {
            this.staffList = res.data.data;
          }
        });
    },
    //提交分配
    submitFormStaff() {
      let self = this;
      if (!this.staffForm.staffGuid) {
        this.$message.error('请选择人员！');
        return;
      }
      this.fullscreenLoading = true;
      this.api
        .put(`/${serverConfig.msCustomerService}/common/adjust-staff?customerType=4`, this.staffForm)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('分配成功');
            this.dialogCustomer = false;
            this.fullscreenLoading = false;
            this.organisationNames = '';
            this.staffForm.staffGuid = '';
            this.staffForm.guids = [];
            this.multipleSelection = [];
            this.$refs.multipleTable.clearSelection();
            this.getData(false);
          } else {
            this.fullscreenLoading = false;
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    getTenantOperationRelList(flg) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data;
              if (self.tenantList && self.tenantList.length > 0) {
                if (self.$route.query.tenantGuid) {
                  self.page.tenantGuid = self.$route.query.tenantGuid;
                } else {
                  self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
                }
                self.tenantList.forEach(k=>{
                  if(self.page.tenantGuid == k.sendTenantGuid){
                    self.tenantName = k.sendTenantName;
                  }
                })
                self.getData(flg);
              }
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelectionGuid.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelectionGuid = [];
        self.multipleSelectionGuid.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msCustomerService}/potential/customer/delete`, self.multipleSelectionGuid)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.$refs.multipleTable.clearSelection();
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    openMiantainState(flg, guid) {
      if (flg == 1) {
        if (this.multipleSelection.length == 0) {
          this.$message.error('请勾选数据！');
          return;
        }
      }
      this.dialogVisible = true;
      this.MiantainStateflg = flg;
      this.MiantainStateGuid = guid;
    },
    updateMiantainState() {
      let self = this;
      let guids = [];
      if (self.MiantainStateflg == 2) {
        self.multipleSelection = [];
        self.multipleSelection.push(self.MiantainStateGuid);
      }
      this.$confirm('此操作将永久标记, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .put(
              `/${serverConfig.msCustomerService}/common/update-maintain-state?customerType=4&maintainState=` +
                self.maintainState,
              self.multipleSelection,
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('标记成功');
                self.$refs.multipleTable.clearSelection();
                self.dialogVisible = false;
                self.getData(false);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    empty() {
      let self = this;
      (this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        staffName: '',
        startTime: '',
        endTime: '',
        customerName: '',
        tenantGuid: this.page.tenantGuid,
        // filingMethod: '',
        // maintainState: '',
        terminalProperties: [],
        staffInfo:''
      }),
        self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // if(self.multipleSelection && self.multipleSelection.length > 0){
      //   self.$refs.multipleTable.clearSelection();
      // }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCustomerService}/potential/customer/page`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addPath(){
      sessionStorage.removeItem('fillRefresh');
      // if(!localStorage.getItem('YDJD_CONFIG')){
      //   this.$message.error('功能界面内容未配置，请联系运营人员处理')
      //   return
      // }
      this.$router.push({ path: 'pharmacyPotentialAdd', 
        query: { tenantGuid:this.page.tenantGuid, productGuid:this.$route.query.productGuid }
      });
    },
    editPath(guid){
      sessionStorage.removeItem('fillRefresh');
      // if(!localStorage.getItem('YDJD_CONFIG')){
      //   this.$message.error('功能界面内容未配置，请联系运营人员处理')
      //   return
      // }
      this.$router.push({ path: 'pharmacyPotentialAdd', 
      query: { guid: guid,tenantGuid:this.page.tenantGuid, productGuid:this.$route.query.productGuid } 
      });
    },
    batchImport(guid) {
      this.$router.push({ path: '/importNewManagementList',query:{ productGuid:this.$route.query.productGuid,type:'0007'} });
    },
    report() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.page));
      // req.pageSize = -1;
      self.api.postJsonD(`/${serverConfig.msCustomerService}/potential/customer/export`, req)
        .then(res => {
          let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let fileName = '潜在药店客户资料';
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
      // self.empty();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
        self.staffForm.guids.push(item.guid);
      });
      console.log(val);
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
   
  },
};
</script> 
<style scoped>
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>